<template>
    <div class="CookieDisabled">
        Cookie disabled
    </div>
</template>
<script lang="ts">
    import {Component, Vue} from 'vue-property-decorator';

    @Component({})
    export default class CookieDisabled extends Vue {
    }
</script>
<style scoped>
</style>
